module.exports = __webpack_public_path__ + "img/ic_upload.f4199134.svg";